import { fetchSortedSavedSearches, SavedSearch, SavedSearchDto, SavedSearchPage } from '@creditsights/api-ui-web';
import { mapSavedSearchesDtoToModel, searchTags } from '@creditsights/creditsights-web';
import { compareDesc } from 'date-fns';
import { uniq } from 'lodash';
import { useQuery, UseQueryResult } from 'react-query';
import { queryKeys } from '../queryKeyFactory';

export const DEFAULT_SAVED_SEARCHES_COUNT = 3;

export default (): UseQueryResult<SavedSearch[], Error> => {
  return useQuery<SavedSearch[], Error>([queryKeys.savedSearches.all], async () => {
    const sortedSavedSearches = await fetchSortedSavedSearches();
    const globalSearchSavedSearches = sortedSavedSearches.filter(
      (savedSearch) => savedSearch.pageName === SavedSearchPage.GlobalSearch
    );
    const savedSearchTags = globalSearchSavedSearches
      .map((savedSearch) => savedSearch.filters?.map((filter) => filter.tags) || [])
      .flat(2);
    // fetch tags with uniq tagIds from saved search filters
    const tags = savedSearchTags.length > 0 ? await searchTags(uniq(savedSearchTags)) : {};
    const mostRecentSavedSearches = sortSavedSearchesByUpdatedAt(globalSearchSavedSearches);

    return mapSavedSearchesDtoToModel(mostRecentSavedSearches.slice(0, DEFAULT_SAVED_SEARCHES_COUNT), tags);
  });
};

export const sortSavedSearchesByUpdatedAt = (savedSearches: SavedSearchDto[]): SavedSearchDto[] =>
  savedSearches.sort((a, b) => compareDesc(new Date(a.updatedAt), new Date(b.updatedAt)));
